import React from 'react';
import { Landing } from './landing';

const Home = () => <Landing />;

export default Home;
